import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ChatModeSidePanel,
  LeftPanelSections,
  RightPanelSections,
} from 'src/types';
import { RootState } from '../index';
import { BREAKPOINT_DESKTOP } from 'src/constants';

export type UsageTable = 'business' | 'individual' | undefined;

interface InterfaceControl {
  /**
   * @deprecated
   */
  chatModeSidePanel: ChatModeSidePanel;
  /**
   * @deprecated
   */
  isSettingsPanelExpanded: boolean;
  isLeftPanelExpanded: boolean;
  leftPanelSections: LeftPanelSections;
  isRightPanelExpanded: boolean;
  isRightPanelFullWidth: boolean;
  rightPanelSections: RightPanelSections | null;
  isShowAppSwitcherTooltip: boolean;
  isShowRequestUsageTable: boolean;
  usageTableType: UsageTable;
}

const initialState: InterfaceControl = {
  chatModeSidePanel: ChatModeSidePanel.NONE,
  isSettingsPanelExpanded: false,
  isLeftPanelExpanded: window.innerWidth >= BREAKPOINT_DESKTOP ? true : false,
  leftPanelSections: LeftPanelSections.CONVERSATION_LIST,
  isRightPanelExpanded: false,
  isRightPanelFullWidth: false,
  rightPanelSections: null,
  isShowAppSwitcherTooltip: false,
  isShowRequestUsageTable: false,
  usageTableType: undefined,
};

export const interfaceControlSlice = createSlice({
  name: 'interfaceControl',
  initialState,
  reducers: {
    /**
     * @deprecated
     */
    setChatModeSidePanel: (
      state,
      { payload }: PayloadAction<ChatModeSidePanel>,
    ) => {
      state.chatModeSidePanel = payload;
    },
    /**
     * @deprecated
     */
    setIsSettingsPanelExpanded: (
      state,
      { payload }: PayloadAction<boolean | undefined>,
    ) => {
      state.isSettingsPanelExpanded = payload ?? !state.isSettingsPanelExpanded;
    },
    setIsLeftPanelExpanded: (
      state,
      { payload }: PayloadAction<boolean | undefined>,
    ) => {
      state.isLeftPanelExpanded = payload ?? !state.isLeftPanelExpanded;
    },
    setLeftPanelSections: (
      state,
      { payload }: PayloadAction<LeftPanelSections>,
    ) => {
      state.leftPanelSections = payload;
    },
    setIsRightPanelExpanded: (
      state,
      { payload }: PayloadAction<boolean | undefined>,
    ) => {
      state.isRightPanelExpanded = payload ?? !state.isRightPanelExpanded;
    },
    setIsRightPanelFullWidth: (
      state,
      { payload }: PayloadAction<boolean | undefined>,
    ) => {
      state.isRightPanelFullWidth = payload ?? !state.isRightPanelFullWidth;
    },
    setRightPanelSections: (
      state,
      { payload }: PayloadAction<RightPanelSections | null>,
    ) => {
      state.rightPanelSections = payload;
    },
    setIsShowAppSwitcherTooltip: (
      state,
      { payload }: PayloadAction<boolean | undefined>,
    ) => {
      state.isShowAppSwitcherTooltip =
        payload ?? !state.isShowAppSwitcherTooltip;
    },
    setIsShowRequestUsageTable: (
      state,
      { payload }: PayloadAction<UsageTable>,
    ) => {
      state.isShowRequestUsageTable = !!payload;
      state.usageTableType = payload;
    },
  },
});

export const interfaceControlState = (state: RootState) =>
  state.interfaceControl as InterfaceControl;

export const {
  setChatModeSidePanel,
  setIsSettingsPanelExpanded,
  setIsLeftPanelExpanded,
  setLeftPanelSections,
  setRightPanelSections,
  setIsRightPanelFullWidth,
  setIsRightPanelExpanded,
  setIsShowAppSwitcherTooltip,
  setIsShowRequestUsageTable,
} = interfaceControlSlice.actions;

export default interfaceControlSlice.reducer;
